import { Button, IconMap16, IconFilters16, IconSort16, IconSuccess16 } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './TopBar.css';
import { trackFiltersClick, trackSortClick } from './tracking';
import { EOrderField } from '../../repositories/favorites/v1/web-get-user-favorites';
import { EGetMapDataStatus } from '../../types/map';
import { ClickOutside } from '../ClickOutside';

export interface ITopBarStoreProps {
  total: React.ReactNode | null;
  orderField?: EOrderField | null;
  checkbox: React.ReactNode | null;
  massActions: React.ReactNode | null;
  filtersVisible: boolean;
  isMapVisible: boolean;
  isFavoriteEntitiesLength: boolean;
  mapStatus?: EGetMapDataStatus;
  getFavoriteEntities(orderType: EOrderField): void;
  setShowFiltersModal(howFiltersModal: boolean): void;
  setOrderField(orderType: EOrderField): void;
  openMap(): void;
}

export type TTopBarProps = ITopBarStoreProps;

const SORT_TYPE_BUTTONS = [
  { name: 'По дате добавления в избранное', type: EOrderField.Added },
  { name: 'По цене', type: EOrderField.Price },
];

export const TopBar: React.FC<ITopBarStoreProps> = ({
  total,
  orderField,
  checkbox,
  massActions,
  getFavoriteEntities,
  setShowFiltersModal,
  setOrderField,
  filtersVisible,
  isMapVisible,
  isFavoriteEntitiesLength,
  openMap,
  mapStatus,
}) => {
  const [showSortMenu, setShowSortMenu] = React.useState<boolean>(false);

  const closeShowSortMenu = () => {
    setShowSortMenu(false);
  };

  const openShowSortMenu = () => {
    setShowSortMenu(true);
  };

  const handleFilterClick = () => {
    setShowFiltersModal(true);
    trackFiltersClick();
  };

  const handleSortClick = (order: EOrderField) => {
    setOrderField(order);
    getFavoriteEntities(order);
    trackSortClick(order);
    closeShowSortMenu();
  };

  const handleOpenMap = () => {
    openMap();
  };

  const getDefaultName = () => SORT_TYPE_BUTTONS.find(button => button.type === orderField)?.name;

  return (
    <div className={styles['container']}>
      <div className={styles['total']}>
        {checkbox && <div className={styles['checkbox']}>{checkbox}</div>}
        {total && <span className={styles['total-count']}>{total}</span>}
        <ClickOutside onOutside={closeShowSortMenu}>
          <Button
            theme="fill_white_primary"
            size="XS"
            beforeIcon={<IconSort16 color="primary_100" />}
            onClick={openShowSortMenu}
          >
            {getDefaultName()}
          </Button>
          {showSortMenu && (
            <div className={styles['sort-container']} data-testid="sort_buttons" data-name="SortButtons">
              <ul className={styles['sort-list']}>
                {SORT_TYPE_BUTTONS.map(button => (
                  <li
                    key={button.type}
                    {...mergeStyles(
                      styles['sort-list-item'],
                      button.type === orderField && styles['sort-list-item--active'],
                    )}
                    onClick={() => handleSortClick(button.type)}
                  >
                    {button.name}
                    {button.type === orderField && <IconSuccess16 color="primary_100" />}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </ClickOutside>
        {filtersVisible && (
          <Button
            theme="fill_white_primary"
            size="XS"
            onClick={handleFilterClick}
            beforeIcon={<IconFilters16 color="primary_100" />}
          >
            Фильтр
          </Button>
        )}
        {isMapVisible && (
          <Button
            theme="fill_white_primary"
            size="XS"
            onClick={handleOpenMap}
            beforeIcon={<IconMap16 color="current_color" />}
            loading={mapStatus === EGetMapDataStatus.Loading}
            disabled={!isFavoriteEntitiesLength}
          >
            Посмотреть объекты на карте
          </Button>
        )}
      </div>
      {massActions && <div className={styles['buttons']}>{massActions}</div>}
    </div>
  );
};
